
	import { Vue } from 'vue-class-component'

	export default class VoiceRecognition extends Vue {
		recognizing = false
		recognition: any = null
		recordedText = ''

		created() {
			const { webkitSpeechRecognition } = window as any
			const recognition = new webkitSpeechRecognition()
			recognition.lang = 'ja-JP'
			recognition.continuous = true
			recognition.interimResults = true

			this.recognizing = true

			recognition.onresult = this.recognize
			this.recognition = recognition
			this.recognition.start()
		}

		stopRecord() {
			this.recognition.stop()
			setTimeout(() => {
				this.$emit('stopTalking', this.recordedText)
			}, 500)
		}

		protected recognize(e: any) {
			console.log(e.results)
			this.recordedText = `${e.results[e.results.length - 1][0].transcript}、`
		}
	}
